import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

function Content() {
  const { pageKey } = useParams() ?? "404";
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/${pageKey}`)
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error(`Error loading ${pageKey} content`, err));
  }, [pageKey]);

  if (!data) return null;

  return (
    <div className="pane pane-center">
      <h1>{data.title}</h1>

      {data.content && (
        <div dangerouslySetInnerHTML={{ __html: data.content }} />
      )}

      {(data.paragraphs || []).map((p, i) => {
        const Heading = p.headingLevel || "h2";
        return (
          <section key={i}>
            {p.heading && <Heading>{p.heading}</Heading>}
            {p.body && <div dangerouslySetInnerHTML={{ __html: p.body }} />}
          </section>
        );
      })}
    </div>
  );
}

export default Content;
